export default function YourRights() {
    return (
        <section>
            <h2 id="your-rights" data-testid="your-rights">
                VII. SEUS DIREITOS
            </h2>
            <p>
                Em cumprimento à regulamentação aplicável, no que diz respeito
                ao tratamento de dados pessoais, a AMBEV respeita e garante ao
                Usuário, a possibilidade de apresentação de solicitações
                baseadas nos seguintes direitos:
            </p>
            <ol type="i">
                <li>a confirmação da existência de tratamento;</li>
                <li>o acesso aos dados;</li>
                <li>
                    a correção de dados incompletos, inexatos ou desatualizados;
                </li>
                <li>
                    a anonimização, bloqueio ou eliminação de dados
                    desnecessários, excessivos ou tratados em desconformidade;
                </li>
                <li>
                    a portabilidade de seus dados a outro fornecedor de serviço
                    ou produto, mediante requisição expressa pelo Usuário;
                </li>
                <li>
                    a eliminação dos dados tratados com consentimento do
                    Usuário;
                </li>
                <li>
                    a obtenção de informações sobre as entidades públicas ou
                    privadas com as quais a AMBEV compartilhou seus dados;
                </li>
                <li>
                    a informação sobre a possibilidade de não fornecer o seu
                    consentimento, bem como de ser informado sobre as
                    consequências, em caso de negativa;
                </li>
                <li>a revogação do consentimento.</li>
            </ol>
            <p>
                Parte destes direitos poderá ser exercida diretamente pelo
                Usuário, a partir da gestão de informações sobre sua conta,
                enquanto outros dependerão do envio de solicitação para
                posterior avaliação e adoção de demais providências pela AMBEV.
            </p>

            <p>
                Caso necessite de qualquer auxílio para exercer seus direitos, o
                Usuário pode entrar em contato com a AMBEV, conforme orientações
                nesta Política.
            </p>
        </section>
    );
}
